import { LoadingButton } from "@mui/lab";
import { styled } from "@mui/material";

const FullWidthButton = styled(LoadingButton)`
  display: block;
  margin-top: ${({ theme }) => theme.spacing(1)};
  & .MuiLoadingButton-loadingIndicator {
    top: 0%;
  }
`;

const Container = styled("footer")`
  flex-grow: 1;
  align-content: flex-end;
  padding: ${({ theme }) => theme.spacing(2)};
  position: sticky;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: transparent;
  backdrop-filter: blur(24px);
  z-index: 1;
`;

export { FullWidthButton, Container };
